var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhenxuangu"},[_c('jgySdk',{attrs:{"statName":"yyzs","jgyOutStyle":"{}","divclass":"message_padding white","answer":_vm.answers}}),(_vm.moreInfo)?_c('div',{staticClass:"page_more_link f14",on:{"click":_vm.jumpMoreLink}},[_vm._v(_vm._s(_vm.moreInfo.showText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }